import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { VideoPlayerDataType } from '@/modules/types/videoPlayer';

export const videoPlayerAdaptor = createEntityAdapter();

const initialState: VideoPlayerDataType = videoPlayerAdaptor.getInitialState({
  loaded: false,
  options: [],
});

const videoPlayerSlice = createSlice({
  name: 'videoPlayer',
  initialState,
  reducers: {
    getVideoOptions: (state, action) => {
      state.loaded = false;
      state.options = [];
      if (action.payload.options.length) {
        state.options = action.payload.options;
        state.loaded = action.payload.loaded;
      }
    },
  },
});

export const { name, actions, reducer } = videoPlayerSlice;
